const Modals = {
	ADDJOB: "ADDJOB",
	AROUND: "AROUND",
	AUTH: "AUTH",
	BANNER: "BANNER",
	CATEGORY: "CATEGORY",
	DELETE: "DELETE",
	EDIT: "EDIT",
	LADDER: "LADDER",
	LOCATION: "LOCATION",
	MANAGE: "MANAGE",
	PAYMENT: "PAYMENT",
	PUBLISHED: "PUBLISHED",
	SORT: "SORT",
	SPECIAL: "SPECIAL",
	SUBSCRIPTION: "SUBSCRIPTION",
};

const Patterns = {
	username: /^[A-Za-z0-9]([A-Za-z0-9_]{1,48})[A-Za-z0-9_]$/,
	urlname: /^[A-Za-z]([A-Za-z0-9-]{1,48})[A-Za-z0-9-]$/,
	mobile: /^(09)[0-9]{9}$/,
	email: /^\w+([-.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
	name: /^[A-Za-z\u0600-\u06FF\u200c][A-Za-z\u0600-\u06FF\u200c ]{1,48}[A-Za-z\u0600-\u06FF\u200c]$/,
	rolename:
		/^[A-Za-z0-9\u0600-\u06FF\u200c][0-9A-Za-z\u0600-\u06FF\u200c ]{1,48}[A-Za-z0-9\u0600-\u06FF\u200c]$/,
	latlong: /^[0-9]{2,3}(\.)[0-9]{6}$/,
	tag: /^[a-zA-Z0-9_\u0600-\u06FF\u200c]{2,20}$/,
};

const Permissions = {
	VIEW_USER: "view_user",
	CREATE_USER: "create_user",
	UPDATE_USER: "update_user",
	DELETE_USER: "delete_user",
	STATUS_USER: "status_user",

	VIEW_ROLE: "view_role",
	CREATE_ROLE: "create_role",
	UPDATE_ROLE: "update_role",
	DELETE_ROLE: "delete_role",
	STATUS_ROLE: "status_role",
	ATTACH: "attach",

	VIEW_CATEGORY: "view_category",
	CREATE_CATEGORY: "create_category",
	UPDATE_CATEGORY: "update_category",
	DELETE_CATEGORY: "delete_category",
	STATUS_CATEGORY: "status_category",

	VIEW_JOB: "view_job",
	CREATE_JOB: "create_job",
	UPDATE_JOB: "update_job",
	DELETE_JOB: "delete_job",
	STATUS_JOB: "status_job",

	VIEW_BANNER: "view_banner",
	CREATE_BANNER: "create_banner",
	UPDATE_BANNER: "update_banner",
	DELETE_BANNER: "delete_banner",
	STATUS_BANNER: "status_banner",

	VIEW_FAQ: "view_FAQ",
	CREATE_FAQ: "create_FAQ",
	UPDATE_FAQ: "update_FAQ",
	DELETE_FAQ: "delete_FAQ",
	STATUS_FAQ: "status_FAQ",

	VIEW_TAC: "view_TAC",
	UPDATE_TAC: "update_TAC",
};

const Status = {
	default: { active: "active", inactive: "inactive" },
	user: { active: "active", banned: "banned", pending: "pending" },
};

const Types = {
	phoneNumber: { mobile: "mobile", phone: "phone", fax: "fax" },
	upload: {
		banner: "banner",
		category: "category",
		default: "default",
		job: "job",
		user: "user",
	},
	uploadCategory: { test: "test" },
	uploadValidFormats: ["image/jpg", "image/jpeg", "image/png", "image/bmp"],
};

export { Modals, Patterns, Permissions, Status, Types };
